import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaMapMarkerAlt, FaPhone, FaEnvelope, FaCode } from 'react-icons/fa';

const Footer: React.FC = () => {
  return (
    <footer className="bg-primary text-white font-body">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 font-heading">Moulin Tala</h3>
            <div className="space-y-2">
              <p className="flex items-center">
                <span className="mr-2"><FaMapMarkerAlt /></span>
                <span>62 Route du Moulin Tala, 58140 BRASSY</span>
              </p>
              <p className="flex items-center">
                <span className="mr-2"><FaPhone /></span>
                <span>03 86 22 22 61</span>
              </p>
              <p className="flex items-center">
                <span className="mr-2"><FaEnvelope /></span>
                <span>contact@moulin-tala.fr</span>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4 font-heading">Liens Rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/restaurant" className="hover:text-accent transition-colors">
                  Restaurant
                </Link>
              </li>
              <li>
                <Link to="/etangs" className="hover:text-accent transition-colors">
                  Pêche & Étangs
                </Link>
              </li>
              <li>
                <Link to="/tarifs" className="hover:text-accent transition-colors">
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-accent transition-colors">
                  Nous Contacter
                </Link>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h3 className="text-xl font-bold mb-4 font-heading">Horaires d'Ouverture</h3>
            <p className="text-sm text-accent">Mars à Novembre</p>
            <div className="space-y-2 mt-2">
              <p>
                <span className="font-medium">Jours d'ouverture :</span>
                <br />Du mercredi au dimanche
                <br /><span className="text-xs">(Ouvert tous les jours du 14 juillet au dernier week-end d'août ainsi que les jours fériés)</span>
              </p>
              <p className="mt-3">
                <span className="font-medium">Restaurant :</span>
                <br />12h - 14h uniquement
              </p>
              <p className="mt-3">
                <span className="font-medium">Étangs de pêche :</span>
                <br />8h - 18h
              </p>
            </div>
            <div className="mt-4 flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors">
                <span><FaFacebook size={24} /></span>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors">
                <span><FaInstagram size={24} /></span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center text-sm">
          <p>© {new Date().getFullYear()} Moulin Tala - Tous droits réservés</p>
          
          <p className="mt-4">
            <a 
              href="https://glowsoft.fr" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="flex items-center justify-center text-accent hover:text-white transition-colors"
            >
              <FaCode className="mr-2" /> 
              <span>Créé par Glowsoft</span>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 